import { createContext, useContext, type ReactNode } from 'react';

/** What the chrome shows of the brand the app was built for (the app provides it). */
export interface PortalBranding {
  /** Display name, e.g. "MiCar" — in the login subtitle and the footer's "Powered by". */
  name: string;
  /** The logo, for the pre-login card (the shell takes its own via `AppShell brand`). */
  logo: ReactNode;
  /** Where the login page's sign-up pane links; no pane without it. */
  signUpUrl: string | null;
}

export const PortalBrandingContext = createContext<PortalBranding>({
  name: '',
  logo: null,
  signUpUrl: null,
});

export function usePortalBranding(): PortalBranding {
  return useContext(PortalBrandingContext);
}
